import { styled } from "@linaria/react";
import { css } from "@linaria/core";

export const EventContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2.5rem;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
  height: max-content;
  @media (max-width: 700px) {
    justify-content: center;
  }
`;

export const trainingSessionSlide = css`
  max-height: 450px;
  max-width: 400px;
  .card {
    width: 100%;
    height: 100%;
  }
`;

export const TrainingSessionCard = styled("div")`
  flex-shrink: 0;
  width: 400px;
  height: 450px;
  max-width: 100%;
  border-radius: 1rem;
  text-decoration: none;
  overflow: hidden;
  box-shadow: 1px 1px 10px #03193320;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  transition: all 250ms ease-in-out;
  position: relative;
  color: var(--white);
  background-color: var(--primary-bg);

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    object-position: bottom;
  }
  .card-inner {
    height: calc(100% / 3);
    background: hsl(from var(--primary-bg) h s l / 90%);
    z-index: 1;
    padding: 1.75rem;
    transition: all 250ms ease-in-out;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 2.5rem;
    .hide {
      transition: all 250ms ease-in-out;
      opacity: 0;
    }
  }
  .txt-small {
    font-size: 14px;
  }
  :hover .card-inner {
    height: 100%;
    .hide {
      opacity: 1;
    }
  }
  @media (min-width: 1440px) {
    width: calc((100% - 5rem) / 3);
  }
  @media (max-width: 1320px) {
    width: calc((100% - 2.5rem) / 2);
  }
  @media (max-width: 700px) {
    width: 100%;
    max-width: 400px;
    .card-inner {
      height: fit-content;
      .hide {
        opacity: 1;
      }
    }
    :hover .card-inner {
      height: fit-content;
    }
  }
`;
